<fieldset>
  @if (label) {
    <label [raskRequired]="required">
      {{label}}
      @if (infoText) {
        <rask-info>{{infoText}}</rask-info>
      }
    </label>
  }
  <div class="container" [ngClass]="{disabled: disabled}">
    <button [ngbPopover]="datepickerContent"
      #datepickerToggle="ngbPopover"
      type="button"
      [container]="appendToBody ? 'body' : undefined"
      autoClose="outside"
      triggers="manual"
      popoverClass="datepickerPopover"
      placement="bottom-left auto"
      (click)="toggle(datepickerToggle)">
      <i class="fal fa-calendar-alt"></i>
    </button>
    <input type="text" [disabled]="disabled" id="{{aid}}" #input (blur)="onBlur()" (focus)="onFocus()"
      [ngModel]="inputValue" [ngModelOptions]="{standalone: true}" [placeholder]="placeholder" (change)="manualEdit(input.value)"
      (input)="manualEdit(input.value)" />
      <i class="date-remove" (mousedown)="clear()"
      [ngClass]="{'enabled': value !== undefined}" [hidden]="!isFocused"></i>
    </div>
    @if (rule) {
      <rask-validation-message [rule]="rule"></rask-validation-message>
    }
  </fieldset>

  <ng-template #datepickerContent>
    <!-- Dagar -->
    @if (!onlyMonths) {
      <div class="custom">
        <div class="header-selector">
          <div class="cell" (click)="prevMonth()"><i class="far fa-arrow-left"></i></div>
          <div class="cell header-name">{{viewDate.year}} {{getMonthName()}}</div>
          <div class="cell" (click)="nextMonth()"><i class="far fa-arrow-right"></i></div>
        </div>
        <div class="picker-body">
          <div class="picker-row">
            <div class="cell label day week"></div>
            @for (weekday of weekdays; track weekday) {
              <div class="cell label day">{{weekday}}</div>
            }
          </div>
          @for (week of weeks; track week) {
            <div class="picker-row">
              <div class="cell label week">{{week.week}}</div>
              @for (weekDate of week.dates; track weekDate) {
                <div class="cell date" (click)="selectDate(weekDate); datepickerToggle.close()" [ngClass]="getCellStyle(weekDate)"
                  >
                {{weekDate.day}}</div>
              }
            </div>
          }
        </div>
      </div>
    }

    <!-- Månader -->
    @if (onlyMonths) {
      <div class="custom">
        <div class="header-selector">
          <div class="cell" (click)="prevYear()"><i class="far fa-arrow-left"></i></div>
          <div class="cell header-name">{{viewDate.year}}</div>
          <div class="cell" (click)="nextYear()"><i class="far fa-arrow-right"></i></div>
        </div>
        <div class="picker-body months">
          @for (month of months; track month) {
            <div class="cell month" (click)="selectDate(month.startDate); datepickerToggle.close()" [ngClass]="getCellStyle(month.startDate)"
            >{{month.nameShort}}</div>
          }
        </div>
      </div>
    }
  </ng-template>
